<template>
  <div class="home-component">
    <Slider/>
    <div class="container">
    <nav aria-label="breadcrumb">
     
    </nav>
    </div>
    <template v-if="banner_data != null">
      <BestProducts :banner=banner_data></BestProducts>
    </template>
    <TwoModules></TwoModules>
    <NewModules></NewModules>
    
    
  </div>
</template>
<script>
import { config_settings } from '../config.js';
import axios from "axios";

// @ is an alias to /src

import TwoModules from "@/components/products/TwoModules.vue";
import NewModules from "@/components/products/NewModule.vue";
import Slider from "@/components/slider/Slider.vue"
import HelloWorld from "@/components/HelloWorld.vue";
import BestProducts from "@/components/products/BestProducts.vue";
import TopProducts from "@/components/products/TopProducts.vue";
import Map from "@/components/products/Map.vue";

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const INTERNAL_SERVER_ERROR = 500;
const CONFLICT = 409;

axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  name: "home",
  components: {
    Slider,
    //HelloWorld,
    BestProducts,
    TwoModules,
    NewModules,
   // TopProducts
   Map
  },
  data(){
    return {
      page_title: "",
      page_description: "",
      page_keywords: "",

      slider_list:[],
      imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
      cod_sub_sec: 12,
      nom_sub_sec_es: '',
      nom_sub_sec_en: '',
      internal_name_es: '',
      internal_name_en: '',
      desc_sub_section_es: '',
      desc_sub_section_en: '',
      section: '',
      url_1st_image: 'products/empty-img',
      url_2nd_image: 'products/empty-img',
      url_3rd_image: 'products/empty-img',
      url_4th_image: 'products/empty-img',
      url_5th_image: 'products/empty-img',
      type_1st_image: 'image',
      type_2nd_image: 'image',
      type_3rd_image: 'image',
      type_4th_image: 'image',
      type_5th_image: 'image',
      text1_es: '',
      text1_en: '',
      text2_es: '',
      text2_en: '',
      text3_es: '',
      text3_en: '',
      orientation: '',
      url_es: '',
      url_en: '',
      order_sub_section: '',
      id_position_menu: '',
      url_video: '',
      type: '' ,
      
      banner_data: {
        "first" : { "photo": "products/empty-img", "url": "www.google.com" },
        "second" : { "photo": "products/empty-img", "url" : "www.google.com" },
        "third" : { "photo": "products/empty-img", "url" : "www.google.com" }
      },

      multimedia: []
    }
  },

  metaInfo() {

        return {
             title:  this.page_title ? this.page_title : "",
             meta: [
              { name: 'description', content: this.page_description ? this.page_description : "" },
              { name: 'keywords', content: this.page_keywords ? this.page_keywords : "" },
              { name: 'robots', content: "index" }
            ]
        }
  },

  methods: {
    scroll_inicio(){
      window.scrollTo(0,0);
    },

    obtener_sub_section_data() {
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec)
           .then(response => {
              this.nom_sub_sec_es = response.data.nom_sub_sec_es
              this.nom_sub_sec_en = response.data.nom_sub_sec_en
              this.internal_name_es = response.data.internal_name_es
              this.internal_name_en  = response.data.internal_name_en  
              this.desc_sub_section_es = response.data.desc_sub_section_es  
              this.desc_sub_section_en = response.data.desc_sub_section_en  
              this.section = response.data.section  
              this.url_1st_image = response.data.url_1st_image  
              this.url_2nd_image = response.data.url_2nd_image  
              this.url_3rd_image = response.data.url_3rd_image  
              this.url_4th_image = response.data.url_4th_image  
              this.url_5th_image = response.data.url_5th_image  
              this.type_1st_image = response.data.type_1st_image  
              this.type_2nd_image = response.data.type_2nd_image  
              this.type_3rd_image = response.data.type_3rd_image  
              this.type_4th_image = response.data.type_4th_image  
              this.type_5th_image = response.data.type_5th_image  
              this.text1_es = response.data.text1_es  
              this.text1_en = response.data.text1_en 
              this.text2_es = response.data.text2_es  
              this.text2_en = response.data.text2_en  
              this.text3_es = response.data.text3_es  
              this.text3_en = response.data.text3_en  
              this.orientation = response.data.orientation  
              this.url_es = response.data.url_es  
              this.url_en = response.data.url_en  
              this.order_sub_section = response.data.order_sub_section  
              this.id_position_menu = response.data.id_position_menu  
              this.url_video = response.data.url_video 
              this.type = response.data.type 
             
              this.banner_data = {
                "first" : { "photo": this.url_1st_image, "url" : this.type_1st_image },
                "second" : { "photo": this.url_2nd_image, "url" : this.type_2nd_image },
                "third" : { "photo": this.url_3rd_image, "url" : this.type_3rd_image }
              }

              //SEO
              this.page_title = "ARMAQ PESCA - Cañas, Carretes, Sedales, Señuelos";
              this.page_description = "Empresa dedicada a la importación de productos y accesorios para la pesca deportiva.";
              this.page_keywords = response.data.keywords;

          })
           .catch(error => {
      })
    }
  },
  created() {
    this.scroll_inicio();
    this.obtener_sub_section_data();
    this.getMultimedia()
  }

};
</script>